// src/components/Navbar/Navbar.styles.js
import styled from '@emotion/styled';

export const Dropdown = styled.div`
  position: relative;
  // margin-left: 20px;
  z-index: ${({ isActive }) => (isActive ? 1000 : 1)};
`;

export const LanguageDropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 20px);
  left: 50%;
  transform: translateX(-40%);
  background-color: #385963;
  border: 1px solid #385963;
  border-radius: 10px;
  list-style: none;
  padding: 2px;
  margin: 0;
  z-index: 9999;
  transition: 0.7s;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: auto;
  white-space: nowrap;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  color: white;

  &:focus-within {
    display: block;
  }
`;

export const DropdownItem = styled.li`
  cursor: pointer;
  width: 100%;
  font-size: 13px;
  padding: 6px 0;
  &:hover {
    color: #91abb3;
    border-radius: 10px;
  }
`;

export const DropdownLanguageItem = styled.li`
  padding: 10px 20px;
  cursor: pointer;
  width: 100%;
  font-size: 13px;
  &:hover {
    color: #91abb3;
    border-radius: 10px;
  }
`;

export const LogOutDiv = styled.div`
  display:flex;
  gap: 10px;
  margin-top: 8px;
  align-items:center;
  place-content:center;

  p{
   margin:0;
  }
`;

export const NavContainer = styled("nav")`
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  background-color: transparent;
  position: relative;
  z-index: 9999;
  width:100%;
  gap:20px;
`;

export const LogoImage = styled("img")`
  height: 80px;
  width: 80px;
  background-color: transparent;

  @media (max-width: 768px) {
    height: 80px;
    width: 80px;
  }
  @media (max-width: 480px) {
    height: 70px;
    width: 70px;
  }
`;

export const NavTabs = styled("ul")`

  display: flex;
  list-style: none;
  align-items: center;
  margin: 0;

  & > li {
    // margin-right: 8px;

    a {
      text-decoration: none;
      color: #385963;
      font-size: 13px;
      padding: 10px 0px;
      margin: 0 10px;
      position: relative;

      &:hover {
        color: #91abb3;
        transition: 0.4s;
      }

      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 1.5px;
        bottom: 0;
        left: 50%;
        background-color: #538392;
        transition: all 0.4s;
      }

      &:hover::before {
        width: 100%;
        left: 0;
      }
    }
  }

  @media (max-width: 1024px) {
    & > li a {
      font-size: 13px;
    }
  }

   /* tablet */
  @media (max-width: 992px) {
    & > li a {
      font-size: 10px;
      margin: 0 8px;
    }
  }
  
`;

export const DropdownMenu = styled("ul")`
  position: absolute;
  top: calc(100% + 20px);
  left: 50%;
  transform: translateX(-40%);
  background-color:rgb(56, 89, 99);
  border: 1px solid #385963;
  border-radius: 10px;
  list-style: none;
  padding: 15px;
  gap: 10px;
  margin: 0;
  z-index: 9999;
  transition: 0.7s;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  width: auto;
  white-space: nowrap;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  color: white;

  @media (max-width: 768px) {
    top: calc(100% + 20px);
    left: 50%;
    transform: translateX(-50%);
    padding: 15px;
  }
`;

export const DropdownButton = styled("button")`
  display: flex;
  align-items: center;
  background-color: transparent;
  color: #385963;
  border: none;
  cursor: pointer;
  font-size: 13px;
  margin-top: 3px;
  padding: 0px 10px;
  z-index: ${({ isActive }) => (isActive ? 1001 : 1)};

  svg {
    margin-left: 5px;
    width: 15px;
    height: 15px;
    color: #385963;
  }

  @media (max-width: 992px) {
      font-size: 10px;
      padding:0px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 0px 8px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 0px 6px;
  }
`;

export const MenuFlexBox = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  align-text:center;
`;


export const DropdownNavButton = styled(DropdownButton)`
  font-size: 13px;
  color: #385963;
  text-decoration: none;
  padding: 10px 0;
  margin: 0 10px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    color: #91abb3;
    transition: 0.4s;
  }

  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 1.5px;
    bottom: 0;
    left: 50%;
    background-color: #538392;
    transition: all 0.4s;
  }

  &:hover::before {
    width: 100%;
    left: 0;
  }

`;


// Mobile-friendly dropdown styles

export const MobileDropdown = styled.div`
  position: relative;
  width: 90%;

  display: flex;
  flex-direction: column;
  align-items: center;   /* FIX */
`;

export const MobileDropdownButton = styled.button`
  display: flex;
  // justify-content: space-between;
  justify-content: center;  
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #385963;
  background-color: #f5f7f8;
  border: 1px solid #ccc;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;

  svg {
    margin-left: 10px;
    width: 16px;
    height: 16px;
    transition: transform 0.3s;
  }
    
  &:hover {
    color: #91abb3;
    transition: 0.4s;
  }

 
`;

export const MobileDropdownMenu = styled.ul`
  width: 100%;
  background-color: #385963;
  color: #f0f4f5;
  margin-top: 8px;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0,0,0,0.1);
  padding: 5px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;    
  justify-content: center;
  // gap: 5px;
  z-index: 1000;
`;

export const MobileDropdownItem = styled.li`
  width: 100%;
  padding: 10px 12px;

  font-size: 14px;
  cursor: pointer;

  border-radius: 8px;
  transition: background 0.2s, color 0.2s;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
`;


// export const MobileDropdownItem = styled.li`
//   padding: 10px;
//   font-size: 14px;
//   color: #385963;
//   cursor: pointer;
//   border-radius: 8px;
//   transition: background 0.2s, color 0.2s;
//   padding: 10px 12px;
//   font-size: 14px;
//   color: #385963;
//   cursor: pointer;
//   border-radius: 8px;
//   transition: background 0.2s, color 0.2s;
//   display: flex;              
//   align-items: center;
//   justify-content: flex-start; 
//   gap: 6px;                 
//   text-align: left;  


// `;

export const MobileLanguageDropdownMenu = styled(MobileDropdownMenu)`
  background-color: #385963;
  color: #fff;

  ${MobileDropdownItem} {
    color: #fff;

    &:hover {
      background-color: #2c4c5b;
      color: #e0e6e8;
    }
  }
`;
